import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css"; // Import the CSS for the notifications

const showNotification = ({ title, message, type }) => {
  Store.addNotification({
    title: title || "Notification",
    message: message || "This is a default notification",
    type: type || "default", // 'success', 'danger', 'info', 'default', 'warning'
    insert: "top",
    container: "top-right",
    animationIn: ["animated", "fadeIn"],
    animationOut: ["animated", "fadeOut"],
    dismiss: {
      duration: 5000,
      onScreen: true,
      pauseOnHover: true,
    },
  });
};

export default showNotification;
